import { useState } from "react";
import type { Asset } from "../../../../models/asset";
import useAssetCampaign from "../../../../hooks/useAssetCampaign";
import InfoDialog from "../../../../components/dialogs/InfoDialog";

interface ICampaignsDialogProps {
    asset: Asset;
}

export const CampaignsDialog = (props: ICampaignsDialogProps) => {
    const { hasCampaign } = useAssetCampaign();

    const [campaignDialog, setCampaignDialog] = useState(false);
    const [campaignsSize, ] = useState(props.asset?.campaigns?.number ?? 0);

    return (
        <>
            {hasCampaign(props.asset) ? (
                <div
                    className="acoes-oficina cursor-pointer text-center"
                    onClick={() => setCampaignDialog(true)}
                >
                    <span className="rioglyph rioglyph-calendar-today" />
                    {campaignsSize > 0 && (
                        <span className="alert-info"></span>
                    )}
                </div>
            ) : (
                <div className="acoes-oficina text-center">
                    <span className="rioglyph rioglyph-calendar-today" />
                </div>
            )}

            <InfoDialog
                show={campaignDialog}
                title="Campanhas de Campo"
                body={`Existe${campaignsSize > 1 ? "m" : ""} ${campaignsSize} campanha${campaignsSize > 1 ? "s" : ""} de campo disponível${campaignsSize > 1 ? "is" : ""} para esse veículo. Favor agendar com a concessionária`}
                onClose={() => setCampaignDialog(false)}
            />
        </>);
};